import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var KeybindingResolver = /*#__PURE__*/function () {
  function KeybindingResolver(defaultKeybindings, overrides, log) {
    _classCallCheck(this, KeybindingResolver);

    this._log = log;
    this._defaultKeybindings = defaultKeybindings;
    this._defaultBoundCommands = new Map();

    for (var i = 0, len = defaultKeybindings.length; i < len; i++) {
      var command = defaultKeybindings[i].command;

      if (command) {
        this._defaultBoundCommands.set(command, true);
      }
    }

    this._map = new Map();
    this._lookupMap = new Map();
    this._keybindings = KeybindingResolver.combine(defaultKeybindings, overrides);

    for (var _i = 0, _len = this._keybindings.length; _i < _len; _i++) {
      var k = this._keybindings[_i];

      if (k.keypressParts.length === 0) {
        // unbound
        continue;
      }

      if (k.when && k.when.type === 0
      /* False */
      ) {
        // when condition is false
        continue;
      } // TODO@chords


      this._addKeyPress(k.keypressParts[0], k);
    }
  }

  _createClass(KeybindingResolver, [{
    key: "_addKeyPress",
    value: function _addKeyPress(keypress, item) {
      var conflicts = this._map.get(keypress);

      if (typeof conflicts === 'undefined') {
        // There is no conflict so far
        this._map.set(keypress, [item]);

        this._addToLookupMap(item);

        return;
      }

      for (var i = conflicts.length - 1; i >= 0; i--) {
        var conflict = conflicts[i];

        if (conflict.command === item.command) {
          continue;
        }

        var conflictIsChord = conflict.keypressParts.length > 1;
        var itemIsChord = item.keypressParts.length > 1; // TODO@chords

        if (conflictIsChord && itemIsChord && conflict.keypressParts[1] !== item.keypressParts[1]) {
          // The conflict only shares the chord start with this command
          continue;
        }

        if (KeybindingResolver.whenIsEntirelyIncluded(conflict.when, item.when)) {
          // `item` completely overwrites `conflict`
          // Remove conflict from the lookupMap
          this._removeFromLookupMap(conflict);
        }
      }

      conflicts.push(item);

      this._addToLookupMap(item);
    }
  }, {
    key: "_addToLookupMap",
    value: function _addToLookupMap(item) {
      if (!item.command) {
        return;
      }

      var arr = this._lookupMap.get(item.command);

      if (typeof arr === 'undefined') {
        arr = [item];

        this._lookupMap.set(item.command, arr);
      } else {
        arr.push(item);
      }
    }
  }, {
    key: "_removeFromLookupMap",
    value: function _removeFromLookupMap(item) {
      if (!item.command) {
        return;
      }

      var arr = this._lookupMap.get(item.command);

      if (typeof arr === 'undefined') {
        return;
      }

      for (var i = 0, len = arr.length; i < len; i++) {
        if (arr[i] === item) {
          arr.splice(i, 1);
          return;
        }
      }
    }
    /**
     * Returns true if it is provable `a` implies `b`.
     */

  }, {
    key: "getKeybindings",
    value: function getKeybindings() {
      return this._keybindings;
    }
  }, {
    key: "lookupKeybindings",
    value: function lookupKeybindings(commandId) {
      var items = this._lookupMap.get(commandId);

      if (typeof items === 'undefined' || items.length === 0) {
        return [];
      } // Reverse to get the most specific item first


      var result = [],
          resultLen = 0;

      for (var i = items.length - 1; i >= 0; i--) {
        result[resultLen++] = items[i];
      }

      return result;
    }
  }, {
    key: "lookupPrimaryKeybinding",
    value: function lookupPrimaryKeybinding(commandId) {
      var items = this._lookupMap.get(commandId);

      if (typeof items === 'undefined' || items.length === 0) {
        return null;
      }

      return items[items.length - 1];
    }
  }, {
    key: "resolve",
    value: function resolve(context, currentChord, keypress) {
      this._log("| Resolving ".concat(keypress).concat(currentChord ? " chorded from ".concat(currentChord) : ""));

      var lookupMap = null;

      if (currentChord !== null) {
        // Fetch all chord bindings for `currentChord`
        var candidates = this._map.get(currentChord);

        if (typeof candidates === 'undefined') {
          // No chords starting with `currentChord`
          this._log("\\ No keybinding entries.");

          return null;
        }

        lookupMap = [];

        for (var i = 0, len = candidates.length; i < len; i++) {
          var candidate = candidates[i]; // TODO@chords

          if (candidate.keypressParts[1] === keypress) {
            lookupMap.push(candidate);
          }
        }
      } else {
        var _candidates = this._map.get(keypress);

        if (typeof _candidates === 'undefined') {
          // No bindings with `keypress`
          this._log("\\ No keybinding entries.");

          return null;
        }

        lookupMap = _candidates;
      }

      var result = this._findCommand(context, lookupMap);

      if (!result) {
        this._log("\\ From ".concat(lookupMap.length, " keybinding entries, no when clauses matched the context."));

        return null;
      } // TODO@chords


      if (currentChord === null && result.keypressParts.length > 1 && result.keypressParts[1] !== null) {
        this._log("\\ From ".concat(lookupMap.length, " keybinding entries, matched chord, when: ").concat(printWhenExplanation(result.when), ", source: ").concat(printSourceExplanation(result), "."));

        return {
          enterChord: true,
          leaveChord: false,
          commandId: null,
          commandArgs: null,
          bubble: false
        };
      }

      this._log("\\ From ".concat(lookupMap.length, " keybinding entries, matched ").concat(result.command, ", when: ").concat(printWhenExplanation(result.when), ", source: ").concat(printSourceExplanation(result), "."));

      return {
        enterChord: false,
        leaveChord: result.keypressParts.length > 1,
        commandId: result.command,
        commandArgs: result.commandArgs,
        bubble: result.bubble
      };
    }
  }, {
    key: "_findCommand",
    value: function _findCommand(context, matches) {
      for (var i = matches.length - 1; i >= 0; i--) {
        var k = matches[i];

        if (!KeybindingResolver.contextMatchesRules(context, k.when)) {
          continue;
        }

        return k;
      }

      return null;
    }
  }], [{
    key: "_isTargetedForRemoval",
    value: function _isTargetedForRemoval(defaultKb, keypressFirstPart, keypressChordPart, command, when) {
      if (defaultKb.command !== command) {
        return false;
      } // TODO@chords


      if (keypressFirstPart && defaultKb.keypressParts[0] !== keypressFirstPart) {
        return false;
      } // TODO@chords


      if (keypressChordPart && defaultKb.keypressParts[1] !== keypressChordPart) {
        return false;
      }

      if (when) {
        if (!defaultKb.when) {
          return false;
        }

        if (!when.equals(defaultKb.when)) {
          return false;
        }
      }

      return true;
    }
    /**
     * Looks for rules containing -command in `overrides` and removes them directly from `defaults`.
     */

  }, {
    key: "combine",
    value: function combine(defaults, rawOverrides) {
      defaults = defaults.slice(0);
      var overrides = [];

      var _iterator = _createForOfIteratorHelper(rawOverrides),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var override = _step.value;

          if (!override.command || override.command.length === 0 || override.command.charAt(0) !== '-') {
            overrides.push(override);
            continue;
          }

          var command = override.command.substr(1); // TODO@chords

          var keypressFirstPart = override.keypressParts[0];
          var keypressChordPart = override.keypressParts[1];
          var when = override.when;

          for (var j = defaults.length - 1; j >= 0; j--) {
            if (this._isTargetedForRemoval(defaults[j], keypressFirstPart, keypressChordPart, command, when)) {
              defaults.splice(j, 1);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return defaults.concat(overrides);
    }
  }, {
    key: "whenIsEntirelyIncluded",
    value: function whenIsEntirelyIncluded(a, b) {
      if (!b) {
        return true;
      }

      if (!a) {
        return false;
      }

      return this._implies(a, b);
    }
    /**
     * Returns true if it is provable `p` implies `q`.
     */

  }, {
    key: "_implies",
    value: function _implies(p, q) {
      var notP = p.negate();

      var terminals = function terminals(node) {
        if (node.type === 9
        /* Or */
        ) {
          return node.expr;
        }

        return [node];
      };

      var expr = terminals(notP).concat(terminals(q));

      for (var i = 0; i < expr.length; i++) {
        var a = expr[i];
        var notA = a.negate();

        for (var j = i + 1; j < expr.length; j++) {
          var b = expr[j];

          if (notA.equals(b)) {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "contextMatchesRules",
    value: function contextMatchesRules(context, rules) {
      if (!rules) {
        return true;
      }

      return rules.evaluate(context);
    }
  }]);

  return KeybindingResolver;
}();

function printWhenExplanation(when) {
  if (!when) {
    return "no when condition";
  }

  return "".concat(when.serialize());
}

function printSourceExplanation(kb) {
  if (kb.isDefault) {
    if (kb.extensionId) {
      return "built-in extension ".concat(kb.extensionId);
    }

    return "built-in";
  }

  if (kb.extensionId) {
    return "user extension ".concat(kb.extensionId);
  }

  return "user";
}